import React from 'react';
import { Upload, Search, Sparkles, Check } from 'lucide-react';

const AgentFeatureSection = () => {
  const steps = [
    { icon: Upload, label: 'Photo uploaded to Flickr', detail: 'sunset-beach-2024.jpg', time: '2 min ago' },
    { icon: Search, label: 'Agent detected', detail: 'Scanning your photostream...', time: '1 min ago' },
    { icon: Sparkles, label: 'AI processing', detail: 'Generating metadata...', time: '30 sec ago' },
    { icon: Check, label: 'Metadata applied', detail: 'Title, description, and 12 tags written', time: 'Just now' },
  ];

  return (
    <section className="py-32 bg-white" id="features">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center">
          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-stone-900 leading-[1.1]">
              A fully autonomous photo processing agent
            </h2>
            <p className="text-stone-500 mt-4 max-w-md">
              Configure once. The agent monitors your Flickr, SmugMug, or Unsplash account, detects new uploads, and writes metadata automatically. No manual work, ever.
            </p>
          </div>

          <div className="mt-12 lg:mt-0 bg-stone-50 rounded-lg p-8 border border-stone-200">
            <div className="space-y-6">
              {steps.map((step, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-9 h-9 rounded-full bg-stone-200 flex items-center justify-center">
                    <step.icon className="h-4 w-4 text-stone-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-stone-900">{step.label}</span>
                      <span className="text-xs text-stone-400">{step.time}</span>
                    </div>
                    <p className="text-sm text-stone-500 mt-0.5">{step.detail}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-4 border-t border-stone-200">
              <div className="bg-white rounded p-3 border border-stone-200">
                <p className="text-sm font-medium text-stone-900">Golden Hour Beach Paradise</p>
                <p className="text-xs text-stone-500 mt-1">
                  A breathtaking sunset paints the sky in vibrant oranges and pinks over a serene beach...
                </p>
                <div className="flex flex-wrap gap-1 mt-2">
                  {['sunset', 'beach', 'landscape'].map(tag => (
                    <span key={tag} className="bg-stone-100 text-stone-600 text-xs px-2 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentFeatureSection;
